import axios from 'axios';
import { useRouter } from 'vue-router';

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: true,	// process.env로 접근하여 변수 사용
});

async function adminLogin(adminData) {
    try {
        const response = await instance.post('admin_login', adminData);
        return response.data;
    } catch (error) {
        if (error.response) {
            // 서버가 응답을 반환했지만, 상태 코드가 2xx 범위가 아닌 경우
            throw {
                status: error.response.status,
                message: error.response.data.message || '아이디와 비밀번호를 확인해주세요.'
            };
        } else if (error.request) {
            // 요청이 만들어졌지만, 응답을 받지 못한 경우
            throw {
                status: 500,
                message: '서버로부터 응답이 없습니다.'
            };
        } else {
            // 요청을 설정하는 중에 에러가 발생한 경우
            throw {
                status: 500,
                message: '요청 설정 중 오류가 발생했습니다.'
            };
        }
    }
}

async function getAdminHomeInfo() {
    const router = useRouter();
    try {
        const response = await instance.get('/admin/home');
        return {
            status: response.status,
            data: response.data.data
        }
    } catch (error) {
        router.push('/admin_login/login');
    }
}

async function adminLogout() {
    try {
        const response = await instance.get('/admin/logout');
        return {
            status: response.status,

        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }

}

async function getStatistics() {
    const response = await instance.get('/get_statistic');
    return response.data;
}

async function getCheckLogin() {
    const response = await instance.get('/check_login');
    return response.data;
}

async function signUp(signUpData) {
    try {
        const response = await instance.post('/sign_up', signUpData);
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function login(loginData) {
    try {
        const response = await instance.post('/login', loginData);
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function reqEmailPassword(email) {
    try {
        const response = await instance.post('/req_email_password', { email });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function verifyPasswordToken(token) {
    try {
        const response = await instance.get('/verify_token', { params: { token } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }

}

async function resetPassword(token, pwd, pwdchk) {
    try {
        const response = await instance.post('/reset_password', { token, pwd, pwdchk });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getChart1DataMonth(month) {
    try {
        const response = await instance.get('/admin/chart1_month', { params: { month } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getChart1DataYear(year) {
    try {
        const response = await instance.get('/admin/chart1_year', { params: { year } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getChart2DataMonth(month) {
    try {
        const response = await instance.get('/admin/chart2_month', { params: { month } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getChart2DataYear(year) {
    try {
        const response = await instance.get('/admin/chart2_year', { params: { year } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getChart3DataMonth(month) {
    try {
        const response = await instance.get('/admin/chart3_month', { params: { month } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getChart3DataYear(year) {
    try {
        const response = await instance.get('/admin/chart3_year', { params: { year } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getUserList() {
    try {
        const response = await instance.get('/admin/user_list');
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function banUser(data) {
    try {
        const response = await instance.post('/admin/ban_user', { uid: data.uid, ban_cause: data.ban_cause });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function changePlanAPI(data) {
    try {
        const response = await instance.post('/admin/change_plan', data);
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getUserPayList(uid) {
    try {
        const response = await instance.get('/admin/user_pay_list', { params: { uid } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getUserQuotes() {
    try {
        const response = await instance.get('/admin/user_quotes');
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getUserQuotesPeriod(start, end) {
    try {
        const response = await instance.get('/admin/user_quotes_period', { params: { start, end } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getUserQuotesMonth(year) {
    try {
        const response = await instance.get('/admin/chart2_year', { params: { year } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getPaymentQuote(start, end) {
    try {
        const response = await instance.get('/admin/payment_quote', { params: { start, end } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getPaymentQuoteMonth(start, end) {
    try {
        const response = await instance.get('/admin/payment_quote_month', { params: { start, end } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getPaymentQuoteYear(year) {
    try {
        const response = await instance.get('/admin/payment_quote_year', { params: { year } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

async function getPaymentList(start, end) {
    try {
        const response = await instance.get('/admin/payment_list', { params: { start, end } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

const insert_winning = async (data) => {
    try {
        const response = await instance.post('/admin/insert_winning', data);
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

const getWinningList = async () => {
    try {
        const response = await instance.get('/admin/winning_list');
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

const updateWinning = async (data) => {
    try {
        const response = await instance.post('/admin/update_winning', data);
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

const getWinningListByRoundAndRank = async (round, rank) => {
    try {
        const response = await instance.get('/admin/winning_list_by_round', { params: { round, rank } });
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

const getWinNum = async () => {
    try {
        const response = await instance.get('/get_winning_num');
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

const cancelPayment = async (data) => {
    try {
        const response = await instance.post('/admin/cancel_payment', data);
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}

const getDrawList = async () => {
    try {
        const response = await instance.get('/admin/draw_list');
        return {
            status: response.status,
            data: response.data
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.msg
        }
    }
}
export {
    adminLogin, getAdminHomeInfo, adminLogout, getStatistics, getCheckLogin, signUp,
    login, reqEmailPassword, verifyPasswordToken, resetPassword, getChart1DataMonth, getChart1DataYear,
    getChart2DataMonth, getChart2DataYear, getChart3DataMonth, getChart3DataYear, getUserList, banUser, changePlanAPI,
    getUserPayList, getUserQuotes, getUserQuotesPeriod, getUserQuotesMonth, getPaymentQuote, getPaymentQuoteMonth,
    getPaymentQuoteYear, getPaymentList, insert_winning, getWinningList, updateWinning, getWinningListByRoundAndRank,
    getWinNum, cancelPayment, getDrawList
};
